import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <Container style={{ maxWidth: '800px' }} className="py-4">
        <Button
          variant="link"
          className="text-decoration-none mb-3 p-0"
          onClick={() => navigate('/')}
        >
          <i className="bi bi-arrow-left me-2"></i>Back
        </Button>

        <h1>Privacy Policy</h1>
        <p className="text-muted">Last updated: June 1, 2026</p>

        <h2>1. Introduction</h2>
        <p>
          Plum Applications, Inc. ("we", "us", or "our") operates the Plum renovation
          planning service at www.plum-app.com. This Privacy Policy explains how
          we collect, use, store, and protect your personal information when you
          use our Service.
        </p>

        <h2>2. Information We Collect</h2>
        <h3>Account Information</h3>
        <p>
          When you sign in with Google, we receive your name, email address, and
          profile photo from your Google account.
        </p>
        <h3>Project Data</h3>
        <p>
          We store the renovation project information you provide during
          consultations, including chat messages, generated documents, uploaded
          images, and project preferences.
        </p>
        <h3>Usage Data</h3>
        <p>
          We collect information about how you use the Service, including
          message counts, feature usage, and subscription status.
        </p>
        <h3>Analytics Data</h3>
        <p>
          With your consent, we use Google Analytics to collect anonymized usage
          data such as page views, session duration, and browser type. This data
          helps us improve the Service. You can opt out of analytics via the
          cookie consent banner.
        </p>
        <h3>Error Reports</h3>
        <p>
          We automatically collect error information (error messages, stack traces)
          to diagnose and fix technical issues. This data is anonymized and
          rate-limited.
        </p>

        <h2>3. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide and maintain the Service</li>
          <li>Process your renovation consultations and generate documents</li>
          <li>Manage your account and subscription</li>
          <li>Send important service notifications</li>
          <li>Improve the Service based on usage patterns</li>
          <li>Detect and prevent abuse or unauthorized access</li>
        </ul>

        <h2>4. Data Storage and Security</h2>
        <p>
          Your data is stored securely using Google Firebase, hosted on Google
          Cloud infrastructure. We implement industry-standard security measures
          including encrypted connections (HTTPS), access controls, and database
          security rules that restrict access to your own data.
        </p>

        <h2>5. Data Sharing</h2>
        <p>
          We do not sell your personal information. We share data only with:
        </p>
        <ul>
          <li>
            <strong>Google Firebase</strong> — for authentication, database, and
            hosting services
          </li>
          <li>
            <strong>Google Gemini AI</strong> — your chat messages are processed by
            Google's AI to generate renovation plans
          </li>
          <li>
            <strong>Stripe</strong> — for secure payment processing of
            subscriptions
          </li>
          <li>
            <strong>Google Analytics</strong> — for anonymized usage analytics
            (with your consent)
          </li>
        </ul>

        <h2>6. Cookies and Tracking</h2>
        <p>
          We use essential cookies for authentication and session management. With
          your consent, we also use Google Analytics cookies for anonymized usage
          tracking. You can manage your cookie preferences at any time. We also
          use localStorage to save your theme preference.
        </p>

        <h2>7. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>
            <strong>Access your data</strong> — view your projects and account
            information within the app
          </li>
          <li>
            <strong>Delete your data</strong> — permanently delete your account and
            all associated data through the Profile page
          </li>
          <li>
            <strong>Opt out of analytics</strong> — decline or withdraw cookie
            consent at any time
          </li>
          <li>
            <strong>Data portability</strong> — download your renovation documents
            from the Document panel
          </li>
        </ul>

        <h2>8. Data Retention</h2>
        <p>
          We retain your data for as long as your account is active. When you
          delete your account, all associated data (projects, messages, documents,
          and settings) is permanently removed. Error reports are retained for up
          to 90 days for debugging purposes.
        </p>

        <h2>9. Children's Privacy</h2>
        <p>
          The Service is not intended for users under 18 years of age. We do not
          knowingly collect personal information from children.
        </p>

        <h2>10. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you
          of material changes by posting the updated policy with a new "Last
          updated" date. Continued use of the Service constitutes acceptance of
          the revised policy.
        </p>

        <h2>11. Contact</h2>
        <p>
          If you have questions about this Privacy Policy or your data, please
          contact us at{' '}
          <a href="mailto:support@plum-app.com">support@plum-app.com</a>.
        </p>
      </Container>
    </div>
  );
}

export default PrivacyPage;
